export default [
    {
        "fa": "fas fa-chart-line",
        "value": "RadNet Investor Day 2025",
        "linkTo": "https://www.radnet.com/investor-day?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=investor_day"
    },
    {
        "fa": "fab fa-instagram",
        "value": "Instagram",
        "linkTo": "https://www.instagram.com/radnetimaging"
    },
    {
        "fa": "fab fa-facebook",
        "value": "Facebook",
        "linkTo": "https://www.facebook.com/RadNetImaging"
    },
    {
        "fa": "fa-brands fa-threads",
        "value": "Threads",
        "linkTo": "https://www.threads.net/@radnetimaging"
    },
    {
        "fa": "fa-brands fa-x-twitter",
        "value": "Twitter",
        "linkTo": "https://twitter.com/radnetimaging"
    },
    {
        "fa": "fab fa-pinterest",
        "value": "Pinterest",
        "linkTo": "https://www.pinterest.com/RadNetImaging/"
    },
    {
        "fa": "fab fa-youtube",
        "value": "YouTube",
        "linkTo": "https://www.youtube.com/RadNetVideos/"
    },
    {
        "fa": "fab fa-tiktok",
        "value": "TikTok",
        "linkTo": "https://www.tiktok.com/@radnetimaging"
    },
    {
        "fa": "fab fa-linkedin",
        "value": "Linkedin",
        "linkTo": "https://www.linkedin.com/company/14101"
    },
    {
        "fa": "fas fa-microphone",
        "value": "Dr. Howard Berger iHeartRadio Interview",
        "linkTo": "https://kfiam640.iheart.com/featured/ceos-you-should-know-la/content/2025-08-ceos-you-should-know-howard-berger-ceo-founder-of-radnet/"
    },
    {
        "fa": "fas fa-globe",
        "value": "Enhanced Breast Cancer Detection (EBCD)",
        "linkTo": "https://myebcdmammo.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=my_ebcd"
    },
    {
        "fa": "fas fa-globe",
        "value": "MammogramNow",
        "linkTo": "https://breastlink.com/services/mammogramnow?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=mammo_now"
    },
    {
        "fa": "fas fa-microphone",
        "value": "Your Body Podcast",
        "linkTo": "https://www.yourbodyshow.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=your_body_show"
    },
    {
        "fa": "fas fa-pencil-alt",
        "value": "Blog",
        "linkTo": "https://www.radnet.com/los-angeles/blog?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_blog"
    },
    {
        "fa": "fas fa-map-marker-alt",
        "value": "Our Locations",
        "linkTo": "https://www.radnet.com/imaging-centers/california?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_locations/california"
    },
    {
        "fa": "fas fa-heartbeat",
        "value": "RadNet Cardiac Program",
        "linkTo": "https://www.radnet.com/cardiac-imaging?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_cardiac"
    },
    {
        "fa": "fas fa-user-md",
        "value": "RadNet Prostate",
        "linkTo": "https://prostate.radnet.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_prostate"
    },
    {
        "fa": "fas fa-hand-holding-medical",
        "value": "Choice RadNet",
        "linkTo": "https://choice.radnet.com/"
    },
    {
        "fa": "fa fa-briefcase",
        "value": "RadNet Careers",
        "linkTo": "https://careers.radnet.com/careers-home?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_careers/careers-home"
    },
    {
        "fa": "fas fa-female",
        "value": "#MaddyTheMammoCoach",
        "linkTo": "https://breastlink.com/services/mobile-mammography?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=maddy"
    },
    {
        "fa": "fas fa-newspaper",
        "value": "Sheryl Swoopes Essence Article",
        "linkTo": "https://www.essence.com/lifestyle/health-wellness/sheryl-swoopes-mammograms/"
    },
    {
        "fa": "fas fa-play-circle",
        "value": "RadNet TV",
        "linkTo": "https://www.radnet.tv/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_tv"
    },
    {
        "fa": "fas fa-globe",
        "value": "XRayHours.com",
        "linkTo": "https://xrayhours.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=xray_hours"
    },
    {
        "fa": "fas fa-globe",
        "value": "EastXRayHours.com",
        "linkTo": "https://eastxrayhours.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=east_xray"
    },
    {
        "fa": "fas fa-lungs",
        "value": "Lung Cancer Screening",
        "linkTo": "https://radnetimaging.com/low-dose-lung-ct-scan/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=radnet_lungn/"
    }
]